(() => {
  const key = 'bgshopping_wishlist_v1';
  let saved = [];
  try { saved = JSON.parse(localStorage.getItem(key) || '[]'); if (!Array.isArray(saved)) saved = []; } catch {}
  const dialog = document.querySelector('[data-wishlist-dialog]');
  const items = document.querySelector('[data-wishlist-items]');
  function sync() {
    document.querySelectorAll('[data-wishlist-count]').forEach(el => el.textContent = saved.length);
    document.querySelectorAll('[data-favorite]').forEach(el => el.setAttribute('aria-pressed', String(saved.some(p => p.id === el.dataset.id))));
    if (!items) return;
    items.replaceChildren();
    if (!saved.length) { const p = document.createElement('p'); p.textContent = items.dataset.empty; items.append(p); }
    saved.forEach(p => {
      const row = document.createElement('div'); row.className = 'hw-wish-item';
      const img = document.createElement('img'); img.src = p.image; img.alt = ''; img.loading = 'lazy';
      const a = document.createElement('a'); a.href = p.url; a.textContent = p.title;
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = items.dataset.remove;
      remove.addEventListener('click', () => { saved = saved.filter(v => v.id !== p.id); persist(); });
      row.append(img, a, remove); items.append(row);
    });
  }
  function persist() { try { localStorage.setItem(key, JSON.stringify(saved)); } catch {} sync(); }
  document.querySelectorAll('[data-favorite]').forEach(el => el.addEventListener('click', () => {
    const d = el.dataset;
    if (saved.some(p => p.id === d.id)) saved = saved.filter(p => p.id !== d.id);
    else saved.push({id:d.id,title:d.title,url:d.url,image:d.image});
    persist();
  }));
  document.querySelectorAll('[data-wishlist-open]').forEach(el => el.addEventListener('click', () => { sync(); dialog?.showModal(); }));
  document.querySelector('[data-wishlist-close]')?.addEventListener('click', () => dialog.close());
  dialog?.addEventListener('click', e => { if (e.target === dialog) { const r = dialog.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) dialog.close(); } });
  document.addEventListener('click', e => document.querySelectorAll('.hw-category-menu[open]').forEach(el => { if (!el.contains(e.target)) el.open = false; }));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') document.querySelectorAll('.hw-category-menu[open]').forEach(el => el.open = false); });
  sync();
})();
(() => {
 const main = document.querySelector('main');
 if (!main || !main.dataset.template?.startsWith('collection')) return;
 const walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT, {acceptNode(node) {return ['SCRIPT','STYLE','TEXTAREA'].includes(node.parentElement?.tagName) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT;}});
 let node;
 while ((node = walker.nextNode())) { if (/Polycomp|BGElectronics|Euromaster/i.test(node.textContent)) node.textContent = node.textContent.replace(/Polycomp|BGElectronics|Euromaster/gi, 'BGShopping.net'); }
})();
